<template>
  <table class="table-tab__block table" v-if="pivot.length > 0" >
    <caption v-if="!showAlways">
      <button class="gui-btn gui-btn--link" @click.prevent="isVisible = !isVisible">{{isVisible ? "Скрыть подробности": "Показать подробности"}}</button>
    </caption>

    <thead v-if="showHeader && (isVisible || showAlways)">
      <tr>
        <th>
          Сумма
          <span v-if="withTaxes !== undefined">
            ({{withTaxes ? $t('form.lot.with-taxes') : $t('form.lot.without-taxes')}})
          </span>
        </th>
        <th>Валюта предложения</th>
        <th>Валюта оплаты по договору</th>
        <th>Валютная оговорка</th>
        <th v-if="showCommitInfo">{{$t('form.lot.payments.date-of-fixing-price')}}</th>
      </tr>
    </thead>

    <tbody v-if="isVisible || showAlways">
      <template v-for="(item, id) of pivot">
        <tr class="table-tab__border-top">
          <td>{{item.price | price}}</td>
          <td>{{$t(item.currencyBid.label)}}</td>
          <td>{{$t(item.currencyContract.label)}}</td>
          <td>
            <div class="a-checkbox">
              <label class="a-checkbox__label a-checkbox__label--disable">
                <input class="a-checkbox__input"
                       type="checkbox"
                       :checked="!!item.currencyClause">
                <span class="a-checkbox__icon"></span>
              </label>
            </div>
          </td>
          <td v-if="showCommitInfo">
            <date-time :value="item.commitDate" :time="false"></date-time>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
  export default {
    props: {
      bid: {
        type: Object,
        required: true
      },

      part: {
        type: Number
      },

      payment: {
        type: Object
      },

      showHeader: {
        type: Boolean,
        default: true
      },

      showAlways: {
        type: Boolean,
        default: false
      },

      withTaxes: {
        type: Boolean
      }
    },

    data: () => ({
      isVisible: false,
      showCommitInfo: false
    }),

    computed: {
      pivot() {
        const table = [];
        const specs = this.bid.specs.filter(s => !s.dismiss);

        this.showCommitInfo = this.payment !== undefined;

        for(const specItem of specs) {
          let parts = specItem.parts || [];

          if (this.part !== undefined) {
            parts = _.filter(parts, { part: this.part });
          }

          for (const partItem of parts) {
            const key = {
              currencyBid: specItem.currency,
              currencyContract: specItem.currencyContract,
              currencyClause: specItem.currencyClause
            };

            if (this.showCommitInfo) {
              key.extraCost = specItem.isExtra ? specItem.extraCost : 0;

              const commit = _.find(this.payment.commitInfo, key);

              if (commit) {
                key.commitDate = commit.date;
              }
            }

            let tableItem = _.find(table, key);
            if (!tableItem) {
              table.push({...key});
              tableItem = table[table.length - 1];
              tableItem.price = 0;
            }

            let partTotal;

            if (specItem.isExtra) {
              partTotal = (specItem.price * specItem.count / (specItem.percent ? 10000 : 1)) * partItem.count / 10000;
            }
            else {
              partTotal = specItem.price * partItem.count / (specItem.percent ? 10000 : 1);
            }


            if (this.payment) {
              partTotal = partTotal * this.payment.percent / 10000;
            }

            // if (this.showCommitInfo) {
            //   const commit = _.find(this.payment.commitInfo, key);
            //
            //   if (commit) {
            //     tableItem.commitDate = commit.date;
            //   }
            // }

            tableItem.price += partTotal;
          }
        }

        return table.filter(v => v.price > 0);
      }
    }
  }
</script>

<style lang="scss" scoped>
  caption {
    button {
      font-size: 14px;
    }
  }
</style>
